import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function Otp() {
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();

  const handleVerify = async (e) => {
    e.preventDefault();

    // Replace with real API call
    if (otp === "1234") {
      localStorage.setItem("auth", "true");
      navigate("/dashboard");
    } else {
      alert("Invalid OTP");
    }
  };

  return (
    <div className="">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="d-flex align-items-center justify-content-center min-vh-100">
                        <div className="w-50 d-block bg-white shadow-lg rounded my-5">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="p-5">
                                        <h1 className="h5 mb-1 text-center">Welcome Back!</h1>
                                        <p className="text-muted mb-4">Enter your email address and password to access admin panel.</p>
                                        <form onSubmit={handleVerify}>
                                            <div className="form-group">
                                                <input
                                                      type="text"
                                                      placeholder="Enter OTP"
                                                      onChange={(e) => setOtp(e.target.value)}
                                                      className="form-control form-control-user"
                                                      id="exampleInputEmail"
                                                      required
                                                    />
                                            </div>
                                            <button type="submit" className="btn btn-success btn-block waves-effect waves-light">Verify OTP</button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default Otp;
